// Returns { isPro, isLifetime, expiresAt, daysLeft, expiring, expired }
export function getPlanInfo(user) {
  if (!user) return { isPro: false, isLifetime: false, expiresAt: null, daysLeft: null, expiring: false, expired: false };
  const isPro = !!user.is_pro;
  const exp = user.pro_expires_at;
  const wasPro = user.plan === "pro";
  if (wasPro && !exp) {
    return { isPro: true, isLifetime: true, expiresAt: null, daysLeft: null, expiring: false, expired: false };
  }
  if (!exp) {
    return { isPro, isLifetime: false, expiresAt: null, daysLeft: null, expiring: false, expired: false };
  }
  let daysLeft = null;
  try {
    const ms = new Date(exp).getTime() - Date.now();
    daysLeft = Math.ceil(ms / (1000 * 60 * 60 * 24));
  } catch {
    daysLeft = null;
  }
  const expired = wasPro && daysLeft !== null && daysLeft < 0;
  const expiring = isPro && daysLeft !== null && daysLeft <= 7 && daysLeft >= 0;
  return { isPro, isLifetime: false, expiresAt: exp, daysLeft, expiring, expired };
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}
